import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, IsClosed, IsOpen, Times, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { HBox, VBox } from '../../../../components/Box';
import { List, Row, Cell } from '../../../../components/List';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { deleteVehicleProperty, setVehicleProperty } from '../../../Vehicles/actions';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { Input } from '../../../../components/Input';
import { FormField } from '../../../../components/FormFields';
import { UserLabelById } from '../../../Users/components/UserLabelById';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';

import { Cell as ActionCell } from '../Cell';
import { selectVehicle } from '../../../Vehicles/selectors';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { dropRightWhile } from 'lodash';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const Container = styled.div`
  .form-control,
  .form-control .decorated,
  .vehicle-property-loadable.comment {
    width: 100%;
  }
  .comment-text {
    padding: 6px;
    margin-bottom: 12px;
    border-bottom: 1px solid #eee;
  }
  .pane {
    border-top: 1px solid #eee;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 18px;
    }
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      margin: 0 6px 0 0;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }

    .attention {
      color: ${COLOR_PRIMARY_1};

      .plus {
        color: white;
        background-color: ${COLOR_PRIMARY_1};
        border-radius: 12px;
        width: 24px;
        height: 24px;
        text-align: center;
        font-weight: 600;
        margin: 0 6px;
      }
    }
    .vehicle-property-loadable {
      display: inline-block;
    }
  }
`;

const STATE = {
  approve: false,
  value: '',
  'testdrive-data': false,
};

/* eslint-disable react/prefer-stateless-function */
class WIENTJES_proefritComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  onNotTestDrivenBtn() {
    ['nottestdriven', 'task_test_drive_complete', 'task_test_drive'].map(name => {
      if (name == 'task_test_drive') {
        return this.props.setProperty(name, '0');
      }
      return this.props.setProperty(name, '1');
    });
    return this.setState({ approve: false });
  }

  propertyValue(name) {
    return this.vehicle?.[name];
  }

  renderPane(name, title, content) {
    return (
      <div className="pane">
        <HBox vCenter className="title" onClick={this.setStateFn({ [name]: !this.state[name] })}>
          {title}
          <div>{this.state[name] ? <IsOpen /> : <IsClosed />} </div>
        </HBox>
        {this.state[name] ? content : null}
      </div>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal
        onClose={this.reset.bind(this)}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        {this.renderModalBody()}
        <ModalControls>
          <Button onClick={this.props.confirm}>{this.lbl('confirm')}</Button>
          <Button warning onClick={this.setStateFn({ approve: false })}>
            {this.lbl('cancel')}
          </Button>
          <Button onClick={this.onNotTestDrivenBtn.bind(this)} warning>
            {this.lbl('vehicle.nottestdriven')}
          </Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <Label count={vehicle?.walstreet_proefrit_doorlooptijd_counter} ranges={ranges}>
            {vehicle?.walstreet_proefrit_doorlooptijd_counter || '0'}

          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }

  renderModalBody() {
    return (
      <>
        <WithVehicle vehicle_id={this.props.cell.vehicle.id} loader>
          <VBox className={`${this.props.fullFetch ? 'loading' : ''}`} key="body">
            <VehicleHeader vehicle={this.vehicle} />
            {this.renderPane(
              'purchase-data',
              <h1>{this.lbl('interior.inspection.purchase-data')}</h1>,
              <>
                <List>
                  <Row>
                    <Cell>{this.lbl(`vehicle.property.creditor_company`)}</Cell>
                    <Cell>
                      <CompanyLabelById company_id={this.vehicle.creditor_company} />
                    </Cell>
                  </Row>

                  <Row>
                    <Cell>{this.lbl(`vehicle.property.buying_company`)}</Cell>
                    <Cell>
                      <CompanyLabelById company_id={this.vehicle.buying_company} />
                    </Cell>
                  </Row>

                  <Row>
                    <Cell>{this.lbl(`vehicle.property.buying_contact`)}</Cell>
                    <Cell>
                      <UserLabelById user_id={this.vehicle.buying_contact} />
                    </Cell>
                  </Row>
                </List>

                <br />
                <h1>{this.lbl('interior.inspection.taxatiecenter')}</h1>
                <VBox>
                  <List>
                    <Row>
                      <Cell>{this.lbl(`vehicle.property.mileage`)}</Cell>
                      <Cell>
                        <Cell>{this.vehicle.mileage || ''}</Cell>
                      </Cell>
                    </Row>
                  </List>
                </VBox>
              </>,
            )}
            {this.renderPane(
              'testdrive-data',
              <h1>{this.lbl('vehicle.testdrive')}</h1>,
              <VBox className="test-drive-items">
                {['engine_general', 'ac', 'brakes', 'transmission', 'drive', 'electrics'].map(
                  this.renderTripleCheck.bind(this),
                )}
                <HBox vCenter left className="triple triple-1">
                  <div
                    className="check"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      ['engine_general', 'ac', 'brakes', 'transmission', 'drive', 'electrics'].map(type => {
                        this.props.setProperty(`state_${type}`, 1);
                      });
                    }}
                  >
                    +
                  </div>
                  <div className="label" style={{ whiteSpace: 'nowrap' }}>
                    {this.lbl(`all`)}
                  </div>
                </HBox>
              </VBox>,
            )}
          </VBox>
        </WithVehicle>
      </>
    );
  }

  renderTripleCheck(name) {
    name = 'state_' + name;
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    console.log(name + ' : ' + state);
    return (
      <VBox key={name}>
        <HBox vCenter left key={name} className={`triple triple-${state}`}>
          <HBox vCenter left
            // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
          >
            <div className="label" style={{ whiteSpace: 'nowrap' }}>
              {this.lbl(`vehicle.property.${name}`)}
            </div>
            <VehiclePropertyLoadable name={name}>
              <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`} // uniek per veld
                  id={`btnradio1-${name}`}
                  autoComplete="off"
                  checked={state == 0}
                  onChange={() => this.props.setProperty(name, 0)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>Todo</label>

                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`}
                  id={`btnradio2-${name}`}
                  autoComplete="off"
                  checked={state == 1}
                  onChange={() => this.props.setProperty(name, 1)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>Gereed</label>

                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`}
                  id={`btnradio3-${name}`}
                  autoComplete="off"
                  checked={state == 2}
                  onChange={() => this.props.setProperty(name, 2)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>Manco</label>
              </div>
            </VehiclePropertyLoadable>
          </HBox>
          {this.renderCommentToggle(name)}
        </HBox>
        <VehiclePropertyLoadable className="comment" name={`${name}_comment`}>
          {this.renderCommentInput(name)}
        </VehiclePropertyLoadable>
      </VBox>
    );
  }

  renderCommentToggle(name) {
    name = name + '_comment';
    let value = this.propertyValue(name);

    if (this.state.edit == name) {
      return (
        <HBox key={name} className="attention" vCenter right onClick={this.setStateFn({ edit: null, value: null })}>
          <div className="plus">-</div>
        </HBox>
      );
    }
    return (
      <HBox
        key={`${name}-2`}
        className="attention"
        vCenter
        right
        onClick={this.setStateFn({ edit: name, value: value || '' })}
      >
        <span>Aandachtspunt</span>
        <div className="plus">+</div>
      </HBox>
    );
  }

  renderCommentInput(name) {
    name = name + '_comment';
    let value = this.propertyValue(name);
    if (this.state.edit == name) {
      return (
        <FormField key={name}>
          <Input
            key={name}
            name="value"
            onChange={this.onInputChange.bind(this)}
            value={this.state.value}
            rightDecoration={
              <>
                <Button
                  small
                  onClick={() => {
                    this.props.setProperty(name, this.state.value);
                    this.setState({ edit: null });
                  }}
                >
                  <Check />
                </Button>
                <Button
                  warning
                  small
                  onClick={() => {
                    this.props.deleteProperty(name);
                    this.setState({ edit: null });
                  }}
                >
                  <Times />
                </Button>
              </>
            }
          />
        </FormField>
      );
    }

    if (!value || value == '') return null;

    return <div className="comment-text">{value}</div>;
  }
}

WIENTJES_proefritComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm() {
      dispatch(performAction(ownProps.action.id, ownProps.cell.vehicle.id));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.cell.vehicle.id, name));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WIENTJES_proefrit = compose(withConnect, withRouter)(WIENTJES_proefritComp);
